'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import H1 from 'UIComponents/elements/headings/H1';
import { OLAF, CALYPSO, CALYPSO_DARK } from 'HubStyleTokens/colors';
import { FormattedMessage } from 'LearningCenterUI/components/I18n';
import { device } from '../../constants/StyledComponentConstants';
import useMediaQuery from '../../hooks/useMediaQuery';
import H4 from 'UIComponents/elements/headings/H4';
import { RouterSearchInput } from '../../containers/TracksPage/RouterDropdownFilter';
import { FILTER_TYPES } from '../../constants/TopFilterConstants';
import CatalogDropdownContainer from '../CatalogDropdown/CatalogDropdownContainer';
import UIFlex from 'UIComponents/layout/UIFlex';
import blobsImageUrl from 'bender-url!../../../images/storefront-header-blobs.svg';
const StylesHeader = styled.div.withConfig({
  displayName: "HeadingNav__StylesHeader",
  componentId: "y4fu2h-0"
})(["background:", ";background-image:url(", "),linear-gradient(to right,", ",", ");background-position:center center;background-repeat:no-repeat;background-size:auto 100%;color:", ";text-align:center;padding:40px 16px 0;", " @media screen and ", "{padding-top:14px;padding-bottom:1px;background-image:none;}"], CALYPSO, blobsImageUrl, CALYPSO_DARK, CALYPSO, OLAF, props => props.stickySearch && ` @media screen and ${device.not.mobile} {
        position: sticky;
        height: 260px;
        top: -130px;
        z-index: 3;
    }`, device.mobile);
const StylesHeaderInner = styled.div.withConfig({
  displayName: "HeadingNav__StylesHeaderInner",
  componentId: "y4fu2h-1"
})(["@media screen and ", "{height:140px;", "}"], device.not.mobile, props => props.stickySearch && ` @media screen and ${device.not.mobile} {
          position: sticky;
          top: -36px;
    }`);
const SearchContainerResponsive = styled.div.withConfig({
  displayName: "HeadingNav__SearchContainerResponsive",
  componentId: "y4fu2h-2"
})(["max-width:492px;margin:0 auto;margin-bottom:12px;"]);
const SearchContainer = styled.div.withConfig({
  displayName: "HeadingNav__SearchContainer",
  componentId: "y4fu2h-3"
})(["width:492px;max-width:492px;margin-left:20px;"]);
const FlexContainer = styled(UIFlex).withConfig({
  displayName: "HeadingNav__FlexContainer",
  componentId: "y4fu2h-4"
})(["padding-top:4px;"]);
const SubHeaderTitle = styled(FormattedMessage).withConfig({
  displayName: "HeadingNav__SubHeaderTitle",
  componentId: "y4fu2h-5"
})(["font-size:18px;font-weight:400;"]);

const HeadingNav = ({
  hideStylesHeader,
  titleKey,
  withSearch,
  searchResultsRedirect
}) => {
  const isMobile = useMediaQuery(`screen and ${device.mobile}`);
  const isTouchscreen = useMediaQuery(`(hover: none) and (pointer: coarse)`);
  return /*#__PURE__*/_jsx(Fragment, {
    children: !hideStylesHeader && /*#__PURE__*/_jsx(StylesHeader, {
      stickySearch: withSearch,
      children: /*#__PURE__*/_jsx(StylesHeaderInner, {
        stickySearch: withSearch,
        children: isMobile ? /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(H4, {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: `learningCenter.heading.headingTitles.${titleKey}`
            })
          }), withSearch && /*#__PURE__*/_jsxs(SearchContainerResponsive, {
            children: [/*#__PURE__*/_jsx(RouterSearchInput, {
              clearCatalogFilters: true,
              filterType: FILTER_TYPES.SEARCH,
              searchResultsRedirect: searchResultsRedirect
            }), /*#__PURE__*/_jsx(CatalogDropdownContainer, {})]
          })]
        }) : /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(H1, {
            className: withSearch ? 'm-bottom-3' : 'm-bottom-3 p-top-4',
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: `learningCenter.heading.headingTitles.${titleKey}`
            })
          }), /*#__PURE__*/_jsx("p", {
            children: /*#__PURE__*/_jsx(SubHeaderTitle, {
              message: `learningCenter.heading.headingSubTitles.${titleKey}`
            })
          }), withSearch && /*#__PURE__*/_jsxs(FlexContainer, {
            justify: 'center',
            children: [/*#__PURE__*/_jsx(CatalogDropdownContainer, {}), /*#__PURE__*/_jsx(SearchContainer, {
              children: /*#__PURE__*/_jsx(RouterSearchInput, {
                autoFocus: !isTouchscreen,
                clearCatalogFilters: true,
                filterType: FILTER_TYPES.SEARCH,
                searchResultsRedirect: searchResultsRedirect,
                size: 'xl'
              })
            })]
          })]
        })
      })
    })
  });
};

HeadingNav.propTypes = {
  hideStylesHeader: PropTypes.bool,
  searchResultsRedirect: PropTypes.bool,
  titleKey: (props, propName, componentName) => !props['hideStylesHeader'] && typeof props[propName] !== 'string' && new Error(`${propName} prop in ${componentName} must be a string when hideStylesHeader is falsy`),
  withSearch: PropTypes.bool
};
HeadingNav.defaultProps = {
  hideStylesHeader: false
};
export default HeadingNav;